/**
 * Financial Page Pagination
 *
 * @module
 */

import { $$, up } from '../../utilities/QuerySelectors.js';

/**
 * Update the table content to reflect the selected page.
 *
 * @private
 * @param {HTMLElement} btn The pagination button just clicked.
 * @return {void}
 */
function triggerChange(btn)
{
    const container = up(btn, '.market-announcements');
    if (!container) {
        console.warn('Could not find the container ancestor for pagination button.', btn);
        return;
    }
    const table = container.querySelector('table');
    if (!table) {
        console.warn('Could not find the table for pagination button.', btn);
        return;
    }
    table.dispatchEvent(new Event('datachange'));
    table.dispatchEvent(new Event('htmlchange'));
}

/**
 * Initialize JS pagination of the announcements table.
 *
 * @return {void}
 */
export function init() {
    $$('.announcements-pagination button').forEach(btn => {
        btn.addEventListener('click', () => setTimeout(() => triggerChange(btn), 1000));
    });
}
